import React from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';

function Contact({ onBack }) {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <h1>{t('contact_title')}</h1>
      <p>{t('contact_p1')}</p>
      <p><strong>{t('contact_p2')}</strong></p>
      <button className="back-button" onClick={onBack}>{t('back_to_home')}</button>
    </div>
  );
}
export default Contact;
